<template>
  <RadioInputList
    :id="$attrs.id || 'AutoManufacturerYearsRadioList'"
    :key="$attrs.key || 'AutoManufacturerYearsRadioList'"
    v-bind="$attrs"
    :title="$attrs.title || 'Qual é o estado de licenciamento do veículo?'"
    :options="$attrs.options || cptdStateList"
    :searchable="false"
    @input="$emit('input', $event)"
  />
</template>
<script>
import states from '@/helpers/states'
import RadioInputList from '@/components/ui/newComponents/RadioInputList.vue'
export default {
  name: 'StateRadioList',
  components: {
    RadioInputList,
  },
  inheritAttrs: false,
  emits: ['input'],
  computed: {
    cptdStateList() {
      return states.map(({ name, value }) => ({
        id: value,
        label: name,
        value,
      }))
    },
  },
}
</script>
<style lang="scss"></style>
